import React from 'react'

import { exportFormatedMoney, renderRouteRole } from '../../../util/utils'
import { useDispatch, useSelector } from 'react-redux'
import {
  IconButton,
  InputBase,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core'
import classNames from 'classnames'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import PencilIcon from '@material-ui/icons/Edit'
import ReactInputMask from 'react-input-mask'
import { update } from '../EletronicNfseActions'

const List = ({ classes = {}, form = {}, setForm = () => {} }) => {
  const role = useSelector(state => state.auth.role)
  const items = useSelector(state => state.eletronicNfse.items)
  const meta = useSelector(state => state.eletronicNfse.meta)
  const dispatch = useDispatch()

  const handleChangePage = newPage => {
    setForm({
      ...form,
      page: newPage,
    })
  }

  const handleChangeRowsPerPage = event => {
    setForm({
      ...form,
      per_page: event.target.value,
    })
  }

  const handleChangeCompanyStatus = async (company, status) => {
    const data = {
      ...company,
      active: status,
    }

    dispatch(update(data, company?.id))
  }

  return (
    <Paper>
      <TableContainer
        className={classNames({
          [classes.tableContainer]: true,
          [classes.tableStickHeader]: true,
        })}
      >
        <Table stickyHeader size="medium" className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Compania</TableCell>
              <TableCell align="center">Cnpj</TableCell>
              <TableCell align="center">Situação</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((company, index) => (
              <TableRow key={index}>
                <TableCell>{company?.id}</TableCell>
                <TableCell>{company?.company_name}</TableCell>
                <TableCell align="center">
                  <ReactInputMask
                    mask="99.999.999/9999-99"
                    value={company?.cnpj}
                    readOnly
                  >
                    {inputProps => (
                      <InputBase
                        {...inputProps}
                        inputProps={{
                          style: {
                            textAlign: 'center',
                          },
                        }}
                        fullWidth
                      />
                    )}
                  </ReactInputMask>
                </TableCell>
                <TableCell align="center">
                  {renderRouteRole(['administrador', 'lavanderia'], role) ? (
                    <Switch
                      checked={company?.active}
                      onChange={e =>
                        handleChangeCompanyStatus(company, !company.active)
                      }
                    />
                  ) : (
                    <Switch checked={company?.active} />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={Number(meta?.total)}
          rowsPerPage={Number(meta?.per_page)}
          page={Number(meta?.current_page) - 1}
          labelRowsPerPage="Linhas por Página"
          backIconButtonProps={{
            'aria-label': 'previous page',
          }}
          labelDisplayedRows={({ from, to, count }) =>
            `Mostrando linhas ${from}-${to} de ${count}`
          }
          nextIconButtonProps={{
            'aria-label': 'next page',
          }}
          onPageChange={(e, page) => handleChangePage(page + 1)}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Paper>
  )
}

export default List
